module.exports = __webpack_public_path__ + "static/media/is.9e18eabf.svg";